import { Box, Card, CardContent, Typography } from "@mui/material";
import AnimatedNumber from "../../../common/components/AnimatedNumber";
import { SPACING } from "../../../common/constants/spacing";

export const StatCard = ({ title, value, icon: Icon, color, trend }) => (
  <Card sx={{ height: "100%", width: "100%" }}>
    <CardContent>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography color="text.secondary" gutterBottom>
            {title}
          </Typography>

          <Typography variant="h2" sx={{ my: SPACING.sm }} component="div">
            <AnimatedNumber section="admin" value={value} />
          </Typography>
        </Box>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            backgroundColor: `${color}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon size={24} color={color} />
        </Box>
      </Box>
      {trend && (
        <Typography
          variant="bodySm"
          color="success"
        >{`+${trend} this month`}</Typography>
      )}
    </CardContent>
  </Card>
);
